import type { FunnelTemplate } from "@/lib/funnel-planner/engine";

export const adultComplianceTemplate: FunnelTemplate = {
  id: "adult-compliance",
  serviceLine: "adult",
  recommendedBands: ["growth", "enterprise"],
  pdfAccentColor: "#475569",
  defaultTrafficChannels: [
    { id: "custom", label: "Custom / Compliant Source", monthlyVisitors: 1000, acquisitionType: "organic" },
  ],
  defaultStages: [
    { id: "awareness", conversionRate: 100, isEditable: false, stageType: "landing-page" },
    { id: "gate",      conversionRate: 70,  isEditable: true,  stageType: "opt-in-page" },
    { id: "content",   conversionRate: 15,  isEditable: true,  stageType: "sales-page" },
    { id: "lead",      conversionRate: 4,   isEditable: true,  stageType: "order-form" },
    { id: "close",     conversionRate: 20,  isEditable: true,  stageType: "retainer-close" },
  ],
};
